import './App.css';
import '@livekit/components-styles';
import JoinMeeting from './components/JoinMeeting';
import Meet from './components/Meet';

import {
  Routes,
  Route,
} from "react-router-dom";
import { toast } from 'react-toastify';

// Patch getUserMedia globally to show a helpful toast on permission denial.
// Always re-throw so LiveKit and local controls can handle media failures normally.
const originalGetUserMedia = navigator.mediaDevices?.getUserMedia?.bind(navigator.mediaDevices);

if (originalGetUserMedia) {
  navigator.mediaDevices.getUserMedia = async function (constraints) {
    try {
      return await originalGetUserMedia(constraints);
    } catch (err) {
      if (err.name === 'NotAllowedError') {
        toast.info(
          <div>
            Camera or mic was blocked.
            <br />
            <a
              href="https://support.google.com/chrome/answer/2693767"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: '#00f', textDecoration: 'underline' }}
            >
              Click here to allow in Chrome settings
            </a>
            &nbsp; or Refresh Page
          </div>,
          { autoClose: 10000 }
        );
      }
      throw err;
    }
  };
}

export default function App() {

  return (
    <Routes>
      <Route path='/' element={<JoinMeeting />}></Route>
      <Route path='/meet' element={<Meet />}></Route>
    </Routes>
  );
}